const LOCALE_KEY = 'pacilo.user.locale';
const DEFAULT_LOCALE = 'ar';

export const supportedLocales = ['ar', 'en'];

let currentLocale = readStoredLocale();
const listeners = new Set();

function readStoredLocale() {
  try {
    const stored = localStorage.getItem(LOCALE_KEY);
    if (supportedLocales.includes(stored)) {
      return stored;
    }
  } catch {
    // Ignore storage access failures.
  }
  return DEFAULT_LOCALE;
}

export function getLocale() {
  return currentLocale;
}

export function getDirection(locale = currentLocale) {
  return locale === 'ar' ? 'rtl' : 'ltr';
}

export function setLocale(nextLocale, { force = false } = {}) {
  if (!supportedLocales.includes(nextLocale)) {
    applyDocumentLocale(currentLocale);
    return currentLocale;
  }
  if (!force && nextLocale === currentLocale) {
    applyDocumentLocale(currentLocale);
    return currentLocale;
  }
  currentLocale = nextLocale;
  try {
    localStorage.setItem(LOCALE_KEY, nextLocale);
  } catch {
    // Ignore storage access failures.
  }
  applyDocumentLocale(nextLocale);
  listeners.forEach((listener) => listener(nextLocale));
  return currentLocale;
}

export function resetLocale(nextLocale = DEFAULT_LOCALE) {
  return setLocale(nextLocale, { force: true });
}

export function applyDocumentLocale(locale = currentLocale) {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.lang = locale;
  document.documentElement.dir = getDirection(locale);
}

export function subscribeLocale(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
